<div class="row" style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important"><div class="col-11"></div><div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;"><mat-icon style="float:right; cursor: pointer;" (click) = "onNoClick()">cancel</mat-icon></div></div>
<h1 mat-dialog-title>@if (data.type == 1) {
  <span>{{labels.lblEditTest}}</span>
}
@if (data.type == 2) {
  <span>{{labels.lblEditPretest}}</span>
}
@if (data.type == 3) {
  <span>{{labels.lblEditSurvey}}</span>
}
"{{data.name}}"</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" #editForm="ngForm" style="height:350px;">
    <input type="hidden" name="id" [ngModel]='data._id'>
    <div fxLayout="column">
      <mat-form-field appearance="none" fxFlex="60%">
        @if (data.type == 1) {
          <mat-label>{{labels.lblTestName}}</mat-label>
        }
        @if (data.type == 2) {
          <mat-label>{{labels.lblPretestName}}</mat-label>
        }
        @if (data.type == 3) {
          <mat-label>{{labels.lblSurveyName}}</mat-label>
        }
        <input matInput [ngModel]="data.name" name="name" required>
        <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
      </mat-form-field>
      @if (data.type == 1) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>{{labels.lblMinPercentage}}</mat-label>
          @if (assigned == 0) {
            <input matInput [ngModel]="data.minPercentage" name="minPercentage" required>
          }
          @if (assigned.length > 0) {
            <div>{{data.minPercentage}}</div>
          }
          <input type="number" matInput [ngModel]="data.minPercentage" name="minPercentage" hidden>
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        </mat-form-field>
      }
      @if (data.type == 1) {
        <mat-checkbox
          [checked]="isItChecked"
          class="example-margin checkbox"
          (change)="showDurationTime($event)"
          [disabled] = "assigned.length > 0"
          >
          {{labels.lblTestDuration}}
        </mat-checkbox >
      }
      @if (data.type == 1 && showDurTime) {
        <mat-form-field appearance="none" fxFlex="60%">
          <mat-label>{{labels.lblTestDuration}}</mat-label>
          @if (assigned == 0) {
            <input matInput [ngModel]="data.durationTime" name="durationTime">
          }
          @if ((assigned.length > 0) && (data.durationTime != null)) {
            <div>{{data.durationTime}}</div>
          }
          <input matInput [ngModel]="data.durationTime" name="durationTime" hidden>
          <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
        </mat-form-field>
      }

      @if (data.type == 1) {
        <mat-checkbox
          class="example-margin checkbox"
          [disabled]="assigned.length > 0"
          [checked]="data.required"
          (change)="data.required = !data.required"
          fxFlex="60%"
          name="required"
          >
          <mat-label>{{labels.lblRequiredTest}}</mat-label>
        </mat-checkbox>
      }

      @if (data.type == 1) {
        <mat-form-field
          appearance="none"
          fxFlex="60%"
          >
          <mat-label>{{labels.lblNumofAttemptsTest}}</mat-label>
          @if (assigned.length == 0) {
            <input matInput name="numberOfTestDrops" [ngModel]="data.numberOfTestDrops"/>
          }
          @if (assigned.length > 0) {
            <input matInput name="numberOfTestDrops" ngModel="data.numberOfTestDrops" hidden>
          }
          @if (assigned.length > 0) {
            <div>{{data.numberOfTestDrops}}</div>
          }
        </mat-form-field>
      }

      <mat-form-field appearance="none" fxFlex="60%">
        <mat-label>{{labels.lblType}}</mat-label>
        <!-- <mat-select [ngModel]="data.type" name='type' disabled>
        <mat-option value="1">Test</mat-option>
        <mat-option value="2">Pretest</mat-option>
        <mat-option value="3">{{labels.lblSurvey}}</mat-option>
      </mat-select> -->
      <input matInput [ngModel] = "data.type" name = "type" style="color: white" hidden>
      <div>
        @if (data.type == 1) {
          <span>{{labels.lblTest}}</span>
        }
        @if (data.type == 2) {
          <span>{{labels.lblPretest}}</span>
        }
        @if (data.type == 3) {
          <span>{{labels.lblSurvey}}</span>
        }
      </div>
      <mat-error style="margin-bottom:1.5vh !important;">{{labels.lblfieldRequired}}</mat-error>
    </mat-form-field>

    <mat-form-field  appearance="none" fxFlex="60%">
      @if (admin.isAdmin == true) {
        <mat-label>{{labels.lblTrainer}}</mat-label>
      }
      @if (admin.isAdmin == false) {
        <h4 style="font-family: 'Prompt', sans-serif !important;">{{labels.lblTrainer}}</h4>
      }
      @if (admin.isAdmin == false) {
        <input matInput ngModel={{admin._id}} name = "trainerId" hidden>
      }
      @if ((assigned.length > 0) || (admin.isAdmin == false)) {
        <input matInput ngModel={{data.trainerId}} name = "trainerId" hidden>
      }
      @if ((assigned.length > 0) || (admin.isAdmin == false)) {
        <div>{{trainer}}</div>
      }
      @if ((admin.isAdmin == true) && (assigned.length == 0)) {
        <mat-select [ngModel] = "data.trainerId" name='trainerId' #trainerId="ngModel" >
          @for (t of trainers; track t) {
            <mat-option [value] = "t._id">{{t.firstName}} {{t.lastName}}</mat-option>
          }
        </mat-select>
      }
    </mat-form-field>

    <div mat-dialog-actions>
      <!-- <button class="noBtn" mat-button (click)="onNoClick()" type="button">{{labels.lblNo}}</button> -->
      <button class="btn" cdkFocusInitial type="submit">{{labels.lblSave}}</button>
    </div>
  </div>
</form>
</div>



